export const TABS = [
  { id: 'clients', intlId: 'common.clients', key: 'client' },
  { id: 'industries', intlId: 'common.industries', key: 'industry' },
  { id: 'serviceType', intlId: 'common.serviceType', key: 'service_type' }
];
